function lsTest(){
  var test = 'test';
  try { 
        localStorage.setItem(test, test);
        localStorage.removeItem(test);
            return true;
  } catch(e) {
            return false;
  }
}
if(lsTest() != true){
  alert("Local Storage is not supported by your browser.PLease disable private mode or upgrade to modern browser");
  open(location, '_self').close();
} 
    